import { Dialog, DialogContent, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BGImage from "assets/allcheckfull.svg";
import Typography from "components/common/Typography";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import StepContent from "./StepContent";
import WelcomeWizard from "./WelcomeWizard";

const handleClose = (reason: any) => {
  if (reason && reason === "backdropClick") return;
};

function Index() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const onboardingDetails: any = useAppSelector((state) => state.onboardingResponse.onboardingResponse);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const showOnboardingWizardFromLibrary: any = useAppSelector(
    (state) => state.onboardingResponse.showOnboardingWizardFromLibrary
  );

  const [currentPage, setCurrentPage] = useState(showOnboardingWizardFromLibrary || isImpersonated ? 2 : 1);

  return (
    <Dialog fullScreen={matches} maxWidth={"md"} open={true} onClose={handleClose}>
      <DialogContent sx={{ display: "flex", padding: 0 }}>
        <Grid container>
          <Grid
            item
            md={5}
            xs={0}
            sx={{
              margin: 0,
              backgroundPosition: "center bottom",
              backgroundImage: `url(${BGImage})`,
              backgroundColor: tokens.Primary.Primary400,
              backgroundRepeat: "no-repeat",
              backgroundSize: "75%",
              color: tokens.Text.General.Inverse,
              width: "400px",
              display: {
                xs: "none",
                sm: "none",
                md: "inherit",
                minHeight: 450,
                justifyContent: "center"
              }
            }}
          >
            <Typography sx={{ padding: "80px 60px" }} variant={"h5"} showBold>
              {currentPage === 1
                ? `Hilton BOOST`
                : `Set preferences that fit you and match your goals to tailor your experience.`}
            </Typography>
          </Grid>
          <Grid
            container
            sx={{ padding: "16px", minHeight: 500 }}
            width="100%"
            item
            md={7}
            display={"flex"}
            flexDirection="column"
            alignItems="center"
            justifyContent={"space-around"}
          >
            {currentPage === 1 ? (
              <WelcomeWizard setCurrentPage={setCurrentPage} />
            ) : (
              <StepContent onboardingDetails={onboardingDetails} />
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default Index;
